import Node from "./nodeClass"

export default class EnterpriseGraph {
  constructor(container, options = {}) {
    if (!container) return
    const { offsetWidth, offsetHeight } = container

    const defaultOptions = {
      width: offsetWidth,
      height: offsetHeight - 20,
      marginTop: (offsetHeight - 20) / 2,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: offsetWidth,
      textMaxLength: 15
    }
    // 节点颜色
    this.nodeColor = {
      '法定代表人': '#D4B106',
      '实际控制人': '#FF4D4F',
      '最终受益人': '#FF7A45',
      '股东信息': '#13C2C2',
      '主要人员': '#389E0D',
      '高管': '#389E0D',
      '对外投资': '#128BED', // self
      '控股企业': '#FF7875', // self
      '分支机构': '#F9AD14', // self
      '供应商': '#85A5FF',
      '客户': '#42B20C',  // self
      '历史对外投资': '#B37FEB',  // self
    }

    // 箭头指向 (模仿企查查并不是产品给的)
    this.arrowOther = ['法定代表人', '实际控制人', '最终受益人', '股东信息', '主要人员', '高管', '供应商']
    this.arrowSelf = ['对外投资', '控股企业', '分支机构', '客户', '历史对外投资']

    const { width, height, marginTop, marginRight, marginBottom, marginLeft, textMaxLength, props } = Object.assign(defaultOptions, options)
    this.width = width
    this.height = height
    this.marginTop = marginTop
    this.marginRight = marginRight
    this.marginBottom = marginBottom
    this.marginLeft = marginLeft
    this.textMaxLength = textMaxLength
    this.config = props || {
      label: 'label',
      children: 'children'
    }

    this.nodeRectMaxWidth = 0
    this.nodeRectMaxWidthLv1 = 200

    this.container = container
    // 初始比例
    // this.scale = 1

    // 创建折线生成器
    this.theLine = d3.line().x(d => d.x).y(d => d.y)

    // 
    this.root = []
  }
  create(data) {
    this.sourceData = [data].map(e => new Node(e, this.config))

    // 区分左右
    this.left = { ... this.sourceData[0], children: this.sourceData[0].children.filter((e, i) => i < Math.floor(this.sourceData[0].children.length / 2)) }
    this.right = { ... this.sourceData[0], children: this.sourceData[0].children.filter((e, i) => i >= Math.floor(this.sourceData[0].children.length / 2)) }

    this.root = [d3.hierarchy(this.left), d3.hierarchy(this.right)]

    this.createLayout()
    this.createTreeNode()
    // 将缩放对象应用于SVG元素
    this.zoomHandler()
    this.container.appendChild(this.svg.node())
    this.drawTree()

  }

  drawTree() {
    for (let index = 0; index < this.root.length; index++) {

      const root = this.root[index]
      root.x0 = this.height / 2
      root.y0 = 0
      root.descendants().forEach(d => {
        d.id = d.data.id || d.data.uid || (d.data.label + d.data.nodeType)
        d._children = d.children
        d.width = this.computeNodeRectWidth(d)
        d.halfWidth = d.width / 2
      })

      this.update(null, root, index)
    }
  }

  computeNodeRectWidth(d) {
    const marginW = 16

    let text = ''
    if (d.depth == 2) {
      if (d.parent.data.data.nodeType == 7 && d.data.data.job) {
        text += `[${d.data.data.job}]`
      }
      if (d.parent.data.data.nodeType == 2 && d.data.data.percent) {
        text += `[${d.data.data.percent}]`

      }
      if (d.parent.data.data.nodeType == 6 && d.data.data.percent) {
        text += `[${d.data.data.percent}]`
      }
    }

    if (d.data.data.regStatus && ['注销', '吊销/撤销'].includes(d.data.data.regStatus)) {
      text += `[${d.data.data.regStatus}]`
    }

    const textWidth = this.getActualWidthOfChars(d.data.label, { size: 12, family: 'Microsoft YaHei' })
    const tipWidth = text ? this.getActualWidthOfChars(text, { size: 12, family: 'Microsoft YaHei' }) : 0
    const width = textWidth + tipWidth + marginW * 2

    this.nodeRectMaxWidth = Math.max(width, this.nodeRectMaxWidth)

    return width
  }

  expandNode(event, source, i) {
    return this.update(event, source, i)
  }
  getActualWidthOfChars(text, options = {}) {
    text = this.setTextMaxLength(text)
    const { size = 14, family = 'Microsoft YaHei' } = options;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.font = `${size}px ${family}`;
    const metrics = ctx.measureText(text);
    const actual = Math.abs(metrics.actualBoundingBoxLeft) + Math.abs(metrics.actualBoundingBoxRight);
    return Math.max(metrics.width, actual);
  }

  setTextMaxLength(text) {
    if (!text) return
    if (text.length > this.textMaxLength) {
      text = text.slice(0, this.textMaxLength) + '...'
    }
    return text
  }


  createLayout() {
    this.svg = d3.create('svg')
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('viewBox', [0, 0, this.width, this.height])
      .attr('style', 'max-width: 100%; height: auto; font: 12px sans-serif; user-select: none;')

    this.wrap = this.svg.append('g')
  }

  createTreeNode(className) {
    this.gLink = this.wrap.append('g')
      .attr('fill', 'none')
      .attr('stroke', '#ADB3C2')
      .attr('stroke-width', 0.5)
      // .attr('stroke-dasharray', 3)
      .attr('stroke-opacity', 1)
      .attr('class', 'link-group')

    this.gNode = this.wrap.append('g')
      .attr('cursor', 'pointer')
      .attr('pointer-events', 'all')
      .attr('class', 'node-group')


    if (className) {
      this.gNode.attr('class', `node-group ${className}`)
      this.gLink.attr('class', `link-group ${className}`)
    }
  }

  update(event, source, i) {
    this.tree = d3.tree().nodeSize([50, this.nodeRectMaxWidth + 80])
    // 计算布局
    this.tree(this.root[i])
    // console.log('tree', tree)
    this.root[i].descendants().forEach(d => {
      const { x, y } = d
      d.x = y
      d.y = x
      if (i == 0) d.x = -d.x
    })

    const duration = event?.altKey ? 3500 : 250
    const nodesData = this.root[i].descendants()
    console.log('nodesData', nodesData);
    const linksData = this.root[i].links()

    const transition = this.svg.transition().duration(duration)

    const node = this.gNode.selectAll(`.node_${i}`).data(nodesData, d => d.id)
    const link = this.gLink.selectAll(`.link_${i}`).data(linksData, d => d.target.id)

    // 创建 Node
    this.createNode(node, source, transition, i)

    // 创建 Link
    this.createLink(link, source, transition, i)

    // 更新位置
    this.root[i].eachBefore(d => {
      d.x0 = d.x
      d.y0 = d.y
    })
  }

  transformMid(d) {
    const w = this.width / 2
    const h = this.height / 2
    // 移动
    this.svg.transition().duration(350).call(this.zoom.transform, d3.zoomIdentity.translate(w - d.x, h - d.y))
  }

  createNode(node, source, transition, i) {
    const nodeEnter = node.enter().append('g')
      .attr('transform', d => `translate(${source.x0},${source.y0})`)
      .attr('class', `node_${i}`)
      .attr('id', d => `g${d.id}`)

    nodeEnter.filter(d => d.depth != 1).on('click', (event, d) => this.transformMid(d))

    nodeEnter.filter(d => d.depth == 1)
      .on('mouseenter', (event, d) => {
        this.mouseovered(true, d, i)
      })
      .on('mouseleave', (event, d) => {
        this.mouseovered(false, d, i)
      })
      .on('click', (event, d) => {
        if (!d._children) return
        d.children = d.children ? null : d._children
        d3.select(event.currentTarget)
          .selectAll('.vertical-line')
          .attr('style', d => `stroke: rgb(102, 102, 102); stroke-width: 1; ${d.children ? 'visibility: hidden;' : null}`)
        this.expandNode && this.expandNode(event, d, i)
        this.t = d
      })
    // TODO 动态加载
    // nodeEnter.filter(d => d.depth == 2)
    //   .on('click', (event, d) => {
    //     // d.children = d.children ? null : d._children
    //     // 
    //     d.children = qwe.Result.Children
    //     d.data.children = qwe.Result.Children
    //     this.asyncExpandNode && this.asyncExpandNode(event, d, i)
    //   })

    // 添加框
    const nodeRect = nodeEnter.append('rect')
      .attr('width', d => d.width)
      .attr('height', 32)
      .attr('x', d => -d.halfWidth)
      .attr('y', -16)
      .attr('rx', 2)
      .attr('ry', 2)

    // nodeRect.filter(d => d.depth < 2).attr('fill', d => `url(#stream_level${d.depth})`)
    nodeRect.filter(d => d.depth == 0)
      .attr('fill', '#128BED')
    nodeRect.filter(d => d.depth == 1)
      .attr('stroke-width', 0)
      .attr('fill', '#fff')
      .attr('fill-opacity', 0)

    nodeRect.filter(d => d.depth >= 2).attr('fill', '#fff')
      .attr('fill-opacity', 0)
      .attr('stroke-width', 0.5)
      .attr('stroke', d => {
        if (d.depth == 2) {
          return this.nodeColor[d.parent?.data?.label] || '#D0D1D6'
        }
        return this.nodeColor[d.data.label] || '#D0D1D6'
      })

    const text = nodeEnter.append('text')
      .attr('y', 5)
      .attr('x', 0)
      .attr('fill', d => d.depth ? '#000' : '#fff')
      .attr('text-anchor', 'middle')
      .attr('font-size', '12px')
      .attr('paint-order', 'stroke')
      .append('tspan')
      .attr('fill', d => d.depth ? '#333' : '#fff')
      .text(d => this.setTextMaxLength(d.data.label))
    const regStatusText = text.filter(d => {
      return d.data.data.regStatus && ['注销', '吊销/撤销'].includes(d.data.data.regStatus)
    })

    regStatusText.append('tspan')
      .attr('fill', d => d.depth == 0 ? '#000' : '#E36560')
      .text('[')
    regStatusText.append('tspan')
      .attr('fill', d => d.depth == 0 ? '#000' : '#E36560')
      .text(d => d.data.data.regStatus)
    regStatusText.append('tspan')
      .attr('fill', d => d.depth == 0 ? '#000' : '#E36560')
      .text(']')

    const topManager = text.filter(d => {
      return d.depth == 2 && d.parent.data.data.nodeType == 7 && d.data.data.job
    })

    topManager.append('tspan')
      .attr('fill', '#999')
      .text('[')
    topManager.append('tspan')
      .attr('fill', '#999')
      .text(d => d.data.data.job)
    topManager.append('tspan')
      .attr('fill', '#999')
      .text(']')


    const percentText = text.filter(d => {
      return d.depth == 2
        && (d.parent.data.data.nodeType == 2  // 股东
          || d.parent.data.data.nodeType == 6) // 对外投资
        && d.data.data.percent
    })

    percentText.append('tspan')
      .attr('fill', '#999')
      .text('[')
    percentText.append('tspan')
      .attr('fill', '#F9AD14')
      .text(d => d.data.data.percent)
    percentText.append('tspan')
      .attr('fill', '#999')
      .text(']')

    // 添加title
    nodeEnter.append('title').text(d => d.data.label)

    // 添加按钮
    const icon = nodeEnter
      // .filter(d => d._children)
      .filter(d => d.parent && d._children)
      .append('g')
      .attr('class', 'icon-text')
      .attr('opacity', 1)
      .attr('transform', d => `translate(${i ? d.halfWidth : -d.halfWidth},${0})`)

    icon.append('circle')
      .attr('class', 'icon-circle')
      .attr('stroke', 'rgb(102, 102, 102)')
      .attr('fill', 'rgb(255, 255, 255)')
      .attr('stroke-width', '1')
      .attr('r', 5)
      .attr('cy', 0)

    icon.append('line')
      .attr('x1', '-2')
      .attr('y1', '0')
      .attr('x2', '2')
      .attr('y2', '0')
      .attr('stroke', 'rgb(102, 102, 102)')
      .attr('stroke-width', '1')

    icon.append('line')
      .attr('class', 'vertical-line')
      .attr('x1', '0')
      .attr('y1', '-2')
      .attr('x2', '0')
      .attr('y2', '2')
      .attr('stroke', 'rgb(102, 102, 102)')
      .attr('stroke-width', '1')
      .attr('style', d => `${d.children ? 'visibility: hidden;' : null}`)

    // 添加圆
    const iconCircle = nodeEnter
      // .filter(d => d._children)
      .filter(d => d.depth == 1)
      .append('g')
      .attr('class', 'icon-circle')
      .attr('opacity', 1)

    iconCircle.append('circle')
      .attr('class', 'icon-circle')
      // .attr('fill', '#D4B106')
      .attr('fill', d => {
        if (d.depth == 1) {
          return this.nodeColor[d.data?.label] || '#D4B106'
        }
        return '#D4B106'
      })
      .attr('r', 4)
      .attr('cx', d => i ? -d.halfWidth + 10 : d.halfWidth - 10)
      .attr('y', 2)


    // 添加三角
    const iconTriangle = nodeEnter
      // .filter(d => d._children)
      .filter(d => d.depth == 1)
      .append('g')
      .attr('class', 'icon-circle')
      .attr('opacity', 1)
      .attr('transform', d => `translate(${i ? -d.halfWidth - 10 : d.halfWidth + 10},${0})`)

    iconTriangle.append('path')
      .attr('stroke-width', 0)
      .attr('fill', d => {
        if (d.depth == 1) {
          return this.nodeColor[d.data?.label] || '#D4B106'
        }
        return '#D4B106'
      })
      .attr('d', d => {
        // 右侧
        if (i) {
          return this.arrowOther.includes(d.data.label) ? 'M0,0L0,3L9,0L0,-3Z' : 'M0,0L9,-3L9,3Z'
        }
        return this.arrowOther.includes(d.data.label) ? 'M0,0L9,-3L9,3Z' : 'M0,0L0,3L9,0L0,-3Z'
      })

    // 添加移入动画
    const nodeUpdate = node.merge(nodeEnter)
      .transition(transition)
      .attr('transform', d => {
        if (d.depth == 1) {

          const translateX = i ? d.x + d.halfWidth - this.nodeRectMaxWidthLv1 / 2 : d.x - d.halfWidth + this.nodeRectMaxWidthLv1 / 2
          d.offsetLeft = translateX - d.halfWidth
          d.offsetRight = translateX + d.halfWidth
          return `translate(${translateX}, ${d.y})`
        }
        if (d.depth == 2) {
          const translateX = i ? d.x + d.halfWidth - this.nodeRectMaxWidth / 2 : d.x - d.halfWidth + this.nodeRectMaxWidth / 2
          d.offsetLeft = translateX - d.halfWidth
          d.offsetRight = translateX + d.halfWidth
          return `translate(${translateX}, ${d.y})`
        }

        d.offsetLeft = d.x - d.halfWidth
        d.offsetRight = d.x + d.halfWidth
        return `translate(${d.x}, ${d.y})`
      })

    nodeUpdate.on('end', d => {
      if (this.t) {
        this.transformMid(this.t)
        this.t = null
      }
    })

    // 移除动画偏移
    const height = 132
    const padding = 10
    let transitionY = 0
    if (i) transitionY = -(height / 2 + padding)
    const nodeExit = node.exit()
      .transition(transition)
      .attr('transform', d => `translate(${source.x + transitionY}, ${source.y})`)
      .attr('fill-opacity', 0)
      .attr('stroke-opacity', 0)
      .remove()
  }
  mouseovered(t, d) {
    t ? this.nodeRaise(d) : this.nodeLower(d)
  }

  nodeRaise(t) {
    const className = this.arrowOther.includes(t.data.label) ? 'topToBottom' : 'bottomToTop'
    t.correlation.forEach(e => {
      d3.select(e).attr('stroke', d => {
        return this.nodeColor[d.source?.data?.label] || this.nodeColor[d.target?.data?.label] || '#D4B106'
      }).attr('stroke-width', 0.5).classed(className, true).raise()
    })
    // d3.select('#g'.concat(t.id)).raise()
  }
  nodeLower(t) {
    const className = this.arrowOther.includes(t.data.label) ? 'topToBottom' : 'bottomToTop'
    t.correlation.forEach(e => {
      d3.select(e).attr('stroke', '#ADB3C2').attr('stroke-width', 0.5).classed(className, false).lower()
    })
    d3.select(t.correlation[0])
  }

  twoPoints(a, b) {
    let length = Math.abs(a.x - b.x)
    let minX
    if (a.x > b.x) {
      minX = b.x
    } else {
      minX = a.x
    }
    const midPointX = length / 2 + minX
    return {
      az: { x: midPointX, y: a.y },
      bz: { x: midPointX, y: b.y }
    }
  }

  getPathData(sp, ep) {
    sp = { x: sp.x, y: sp.y }
    ep = { x: ep.x, y: ep.y }
    // 计算两个直角折点的坐标
    const { az: midPoint1, bz: midPoint2 } = this.twoPoints(sp, ep)
    return [sp, midPoint1, midPoint2, ep]
  }

  createLine(d, i) {
    let sp = { x: d.source.x, y: d.source.y }
    let ep = { x: d.target.x, y: d.target.y }

    if (d.source.data) {
      if (i) {
        sp = { x: d.source.offsetRight, y: d.source.y }
        ep = { x: d.target.offsetLeft, y: d.target.y }
      } else {
        sp = { x: d.source.offsetLeft, y: d.source.y }
        ep = { x: d.target.offsetRight, y: d.target.y }
      }
    }
    const pathData = this.getPathData(sp, ep)
    return this.theLine(pathData)
  }

  createLink(link, source, transition, i) {
    const linkEnter = link.enter().append('path')
      .attr('d', (d, a, b, c, e) => {
        if (d.source.depth >= 1) {
          if (d.source.correlation) {
            d.source.correlation.push(b[a])
          } else {
            d.source.correlation = [b[a]]
          }
        }
        if (d.target.depth >= 1) {
          if (d.target.correlation) {
            d.target.correlation.push(b[a])
          } else {
            d.target.correlation = [b[a]]
          }
        }
        const o = { x: source.x0, y: source.y0 }
        return '' //this.createLine({ source: o, target: o })
      })

    // 合并
    link.merge(linkEnter).transition(transition)
      .attr('d', d => {
        return this.createLine(d, i)
      })
      .attr('stroke-opacity', 1)
      .attr('fill-opacity', 1)
      .attr('class', `link_${i} `)
      .transition()

    // 移除
    link.exit().transition(transition)
      .attr('d', d => {
        const o = { x: source.x, y: source.y }
        return this.createLine({ source: o, target: o })
      })
      .attr('stroke-opacity', 0)
      .attr('fill-opacity', 0)
      .remove()
  }

  emit(scale) { return scale }

  zoomHandler() {
    const rang = this.r || [0.5, 2.5]

    // 创建一个缩放对象
    const zoom = d3.zoom()
      .scaleExtent(rang) // 设置缩放范围
      .on('zoom', current => {
        const { transform, sourceEvent } = current
        if (transform) {
          this.wrap.attr('transform', transform)
          // 滚轮事件
          if (sourceEvent?.type == 'wheel') {
            this.emit(transform.k)
          }
          this.historyS = transform
        }
      })
    // 将缩放对象应用于SVG元素
    this.svg
      .call(zoom)
      .on('dblclick.zoom', event => event.preventDefault())

    // 设置默认位置
    this.svg.call(zoom.transform, d3.zoomIdentity.translate(this.width / 2, this.height / 2).scale(1))

    this.zoom = zoom
  }
}
